import { withStyles } from "@mui/styles";
import { injectIntl } from "react-intl";
import { Styles } from '../../../../styles/material-styles';
import { useSelector } from "react-redux";
import { Container, Tab, Tabs, Paper } from "@mui/material";
import { styled } from '@mui/system';
import { useState } from "react";
import FormEditDataGoogle from "./form-edit-data-google";
import ModulesConfiguration from "../modules-configuration";
import LlmKeyWordComponent from "../llm-key-word-component";
import LlmEventsDynamics from "../llm-events-dynamics";
import RagConfiguration from "../rag-configuration";
import LlmDocuments from "../llm-documents";
import LlmKnowledgeBases from "../knowledge-bases"
import LlmCalleds from "../llm-calleds"
import LlmArticles from "../llm-articles";
import LlmFaq from "../llm-faq";

const MyPaper = styled(Paper)({
    backgroundColor: (theme) => theme.palette.background.paper,
});

const MyTabs = styled(Tabs)({
    backgroundColor: (theme) => theme.palette.primary.main,
    color: (theme) => theme.palette.primary.contrastText,
});

const FormEditGoogle = (props) => {

    const { intl, classes, loading, match } = props;

    const { llms } = useSelector(state => ({
        llms: state.llms
    }));

    const [tabSelected, setTableSelected] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setTableSelected(newValue);
    }

    return (
        <Container component='main' maxWidth='xl'>
            <div style={{ marginTop: '20px' }}>
                <MyPaper square>
                    <MyTabs
                        value={tabSelected}
                        onChange={handleChangeTab}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label={intl.formatMessage({ id: "data" })} />
                        <Tab label={intl.formatMessage({ id: "events" })} />
                        <Tab label={intl.formatMessage({ id: "events.dynamic" })} />
                        <Tab label={intl.formatMessage({ id: "rag.configuration" })} />
                        <Tab label={intl.formatMessage({ id: "llm.modules.settings.tab" })} />
                        <Tab label={intl.formatMessage({ id: "llm.documents" })} />
                        <Tab label={intl.formatMessage({ id: "knowledgebases" })} />
                        <Tab label={intl.formatMessage({ id: "news" })} />
                        <Tab label={intl.formatMessage({ id: "called.header" })} />
                        <Tab label={intl.formatMessage({ id: "faq" })} />
                    </MyTabs>
                </MyPaper>

                {tabSelected === 0 && (
                    <FormEditDataGoogle
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                    />
                )}

                {tabSelected === 1 && (
                    <LlmKeyWordComponent
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                    />
                )}

                {tabSelected === 2 && (
                    <LlmEventsDynamics
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                        classes={classes}
                    />
                )}

                {tabSelected === 3 && (
                    <RagConfiguration
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                    />
                )}

                {tabSelected === 4 && (
                    <ModulesConfiguration
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                        classes={classes}
                    />
                )}

                {tabSelected === 5 && (
                    <LlmDocuments
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                        hirerid={props.hirerid}
                    />
                )}

                {tabSelected === 6 && (
                    <LlmKnowledgeBases
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                        hirerid={props.hirerid}
                        loading={loading}
                        match={match}
                    />
                )}

                {tabSelected === 7 && (
                    <LlmArticles
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                        hirerid={props.hirerid}
                        match={match}
                    />
                )}

                {tabSelected === 8 && (
                    <LlmCalleds
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                        hirerid={props.hirerid}
                        match={match}
                    />
                )}

                {tabSelected === 9 && (
                    <LlmFaq
                        llm={llms?.llm}
                        onShowNotification={props.onShowNotification}
                        onLoading={props.onSetLoading}
                        hirerid={props.hirerid}
                        match={match}
                    />
                )}
            </div>
        </Container>
    )
}

export default injectIntl(withStyles(Styles)(FormEditGoogle));
